import React, { cache, useEffect, useState } from "react";
import { IoCloseOutline } from "react-icons/io5";
import Customform from "../../../ui/custom-form";
import CustomButton from "../../../ui/custom-button";
import { useDispatch, useSelector } from "react-redux";
import { SetPopupReducerData } from "../../../store/reducer/PopupReducer";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  CourseListApi,
  ProfessorListApi,
  SemesterListApiByCourse,
  SubjectListApiBySemester,
  GetRoomlist,
  AddScheduleApi,
  ScheduleListByIdApi,
  UpdateScheduleListApi,
  fetchCameragrouplistingApi,
} from "../../../api/api";
import { Select } from "antd";
import "antd/dist/reset.css";
import { PulseLoader } from "react-spinners";
import CustomInput from "../../../ui/custom-input";

function AddSchedule() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [course, setCourse] = useState([]);
  const [cameraGroupData, setCameraGroupData] = useState([]);
  const [professor, setProfessor] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [semester, setSemester] = useState([]);
  const [rooms, setRooms] = useState([]);
  const { data } = useSelector((state) => state?.PopupReducer?.modal || {});
  //console.log("data", data);
  const [inputData, setInputData] = useState({
    professor: "",
    schedule_name: "",
    schedules: [
      {
        course: "",
        semester: "",
        subject: "",
        dateTime: new Date(),
        // room: "",
        camera_group_id: "",
      },
    ],
  });

  const FetchData = async () => {
    try {
      const res = await ScheduleListByIdApi(data);
      const schedule = res?.data?.data;

      if (!schedule) return;

      const start = new Date(schedule.schedule_start_time);
      const end = new Date(schedule.schedule_end_time);

      setInputData({
        professor: schedule.professor_id,
        schedules: [
          {
            course: schedule.subject_data[0]?.course_id || "",
            semester: schedule.subject_data[0]?.semester_id || "",
            subject: schedule.subject_data[0]?.subject_id || "",
            date: start,
            startTime: start,
            endTime: end,
            room: schedule.room_id,
          },
        ],
      });

      if (schedule.subject_data[0]?.course_id) {
        const semRes = await SemesterListApiByCourse(
          schedule.subject_data[0].course_id
        );
        if (semRes?.data?.status) setSemester(semRes.data.semesters);
      }

      if (schedule.subject_data[0]?.semester_id) {
        const subRes = await SubjectListApiBySemester(
          schedule.subject_data[0].semester_id
        );
        if (subRes?.data?.status) setSubjects(subRes.data.subjects);
      }
    } catch (error) {
      //console.log("error", error);
    }
  };

  useEffect(() => {
    if (data) {
      FetchData();
    }
  }, []);

  const fetchInitialData = async () => {
    try {
      const [courseRes, professorRes, roomRes] = await Promise.all([
        CourseListApi(),
        ProfessorListApi(),
        GetRoomlist(),
      ]);
      if (courseRes?.data?.status) setCourse(courseRes.data.data);
      if (professorRes?.data?.status) setProfessor(professorRes.data.data);
      if (roomRes?.data?.status) setRooms(roomRes.data.data);
    } catch (error) {
      //console.log("error", error);
    }
  };

  const getCameragroup = async () => {
    try {
      const data = await fetchCameragrouplistingApi();
      if (data?.data?.status === true) {
        setCameraGroupData(data?.data?.data);
      }
    } catch (error) {
      //console.log("error", error);
    }
  };

  useEffect(() => {
    fetchInitialData();
    getCameragroup();
  }, []);

  const handleClose = () => {
    dispatch(SetPopupReducerData({ modalType: "", showModal: false }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputData((prev) => ({ ...prev, [name]: value }));
  };

  const handleScheduleChange = async (index, field, value) => {
    const updated = [...inputData.schedules];
    updated[index][field] = value;

    if (field === "course") {
      try {
        const res = await SemesterListApiByCourse(value);
        if (res?.data?.status === true) setSemester(res?.data?.semesters);
      } catch (err) {
        //console.log("semester error", err);
      }
    }

    if (field === "semester") {
      try {
        const res = await SubjectListApiBySemester(value);
        if (res?.data?.status === true) setSubjects(res?.data?.subjects);
      } catch (err) {
        //console.log("subject error", err);
      }
    }

    setInputData((prev) => ({ ...prev, schedules: updated }));
  };

  const addScheduleBlock = () => {
    setInputData((prev) => ({
      ...prev,
      schedules: [
        ...prev.schedules,
        {
          course: "",
          semester: "",
          subject: "",
          date: new Date(),
          startTime: new Date(),
          endTime: new Date(),
          // room: "",
        },
      ],
    }));
  };

  const removeScheduleBlock = (index) => {
    const updated = [...inputData.schedules];
    updated.splice(index, 1);
    setInputData((prev) => ({ ...prev, schedules: updated }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const professor_id = inputData.professor;
    if (!professor_id) return alert("Please select a professor");

    const s = inputData.schedules[0];

    // Utility to combine date and time
    const combineDateAndTime = (date, time) => {
      const d = new Date(date);
      const t = new Date(time);
      d.setHours(t.getHours(), t.getMinutes(), 0, 0);
      return d;
    };

    const payload = {
      professor_id,
      schedule_name: inputData.schedule_name,
      subject_data: [
        {
          course_id: s.course,
          semester_id: s.semester,
          subject_id: s.subject,
        },
      ],
      schedule_start_time: combineDateAndTime(
        s.date,
        s.startTime
      ).toISOString(),
      schedule_end_time: combineDateAndTime(s.date, s.endTime).toISOString(),
      // room_id: s.room,
      ...(data && { schedule_id: data }),
      camera_group_id: s.camera_group_id,
    };

    setLoading(true);
    try {
      if (data) {
        const detail = await UpdateScheduleListApi(payload, data);
        if (detail) {
          handleClose();
        }
      } else {
        const data = await AddScheduleApi(payload);
        if (data) {
          handleClose();
        }
      }
    } catch (err) {
      console.error("Submission failed", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="rightModal taskModal">
      <div className="modal-header p-3">
        <h5 className="m-0">Add Schedule</h5>
        <button className="btnClose ms-auto" onClick={handleClose}>
          <IoCloseOutline color="#fff" size={20} />
        </button>
      </div>

      <div className="p-4 formBox formCstHeight">
        <Customform onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">Select Professor</label>
            <select
              className="form-select"
              name="professor"
              value={inputData.professor}
              onChange={handleChange}
            >
              <option value="">Select</option>
              {professor.map((prof) => (
                <option key={prof._id} value={prof._id}>
                  {prof.professor_name}
                </option>
              ))}
            </select>
          </div>

          <div className="mb-3">
            <label htmlFor="email">Schedule Name</label>
            <CustomInput
              className="form-control my-2"
              name="schedule_name"
              type="text"
              value={inputData.schedule_name}
              onChange={handleChange}
            />
          </div>

          <hr className="hr my-4" />

          <div>
            {inputData.schedules.map((sch, index) => (
              <div className="mb-3" key={index}>
                <h6 className="fw-semibold">Schedule {index + 1}</h6>
                {inputData.schedules.length > 1 && (
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-danger mb-2"
                    onClick={() => removeScheduleBlock(index)}
                  >
                    Remove
                  </button>
                )}

                <div className="mb-3">
                  <label className="form-label">Select Course</label>
                  <select
                    className="form-select"
                    value={sch.course}
                    onChange={(e) =>
                      handleScheduleChange(index, "course", e.target.value)
                    }
                  >
                    <option value="">Select</option>
                    {course.map((c) => (
                      <option key={c._id} value={c._id}>
                        {c.course_name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="mb-3">
                  <label className="form-label">Select Semester</label>
                  <select
                    className="form-select"
                    value={sch.semester}
                    onChange={(e) =>
                      handleScheduleChange(index, "semester", e.target.value)
                    }
                  >
                    <option value="">Select</option>
                    {semester.map((sem) => (
                      <option key={sem._id} value={sem._id}>
                        {sem.semester_name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="mb-3">
                  <label className="form-label">Select Subject</label>
                  <div className="w-100">
                    <Select
                      className="form-select selectCst"
                      style={{ width: "100%" }}
                      options={subjects.map((s) => ({
                        label: s.subject_name,
                        value: s._id,
                      }))}
                      value={sch.subject}
                      onChange={(selectedValue) =>
                        handleScheduleChange(index, "subject", selectedValue)
                      }
                      placeholder="Select Subject"
                    />
                  </div>
                </div>

                <div className="mb-3">
                  <div className="row">
                    <div className="col-12 mb-3 datePicker">
                      <label className="form-label">Date</label>
                      <DatePicker
                        className="form-control"
                        selected={sch.date}
                        onChange={(date) =>
                          handleScheduleChange(index, "date", date)
                        }
                        dateFormat="yyyy-MM-dd"
                        placeholder="yyyy-MM-dd"
                      />
                    </div>
                    <div className="col-6">
                      <label className="form-label">Start Time</label>
                      <DatePicker
                        selected={sch.startTime}
                        onChange={(time) =>
                          handleScheduleChange(index, "startTime", time)
                        }
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={15}
                        timeCaption="Time"
                        dateFormat="h:mm aa"
                        className="form-control"
                      />
                    </div>
                    <div className="col-6">
                      <label className="form-label">End Time</label>
                      <DatePicker
                        selected={sch.endTime}
                        onChange={(time) =>
                          handleScheduleChange(index, "endTime", time)
                        }
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={15}
                        timeCaption="Time"
                        dateFormat="h:mm aa"
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>

                {/* <div className="mb-3">
                  <label className="form-label">Select Room</label>
                  <select
                    className="form-select"
                    value={sch.room}
                    onChange={(e) =>
                      handleScheduleChange(index, "room", e.target.value)
                    }
                  >
                    <option value="">Select Room</option>
                    {rooms.map((room) => (
                      <option key={room._id} value={room._id}>
                        {room.room_name} ({room.room_no})
                      </option>
                    ))}
                  </select>
                </div> */}

                <div className="col-12 mt-3">
                  <label className="form-label">Camera Group Name</label>
                  <select
                    name="camera_group_id"
                    className="form-select"
                    value={sch.camera_group_id}
                    onChange={(e) =>
                      handleScheduleChange(
                        index,
                        "camera_group_id",
                        e.target.value
                      )
                    }
                  >
                    <option value="">Select Camera Group</option>
                    {cameraGroupData?.map((ele) => (
                      <option key={ele?._id} value={ele?._id}>
                        {ele?.camera_grp_name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            ))}

            <div className="text-end">
              <button
                type="button"
                className="cstLink"
                onClick={addScheduleBlock}
              >
                + Add Another Schedule
              </button>
            </div>
          </div>

          <div className="buttonGroup d-flex justify-content-between position-absolute start-0 bottom-0 w-100 p-4 border-top mt-5 bg-white">
            <button
              className="cancelBtn w-100"
              type="button"
              onClick={handleClose}
            >
              Cancel
            </button>
            {loading ? (
              <button className="nextBtn w-100">
                <PulseLoader color="#fff" />
              </button>
            ) : (
              <button className="nextBtn w-100">Submit</button>
            )}
          </div>
        </Customform>
      </div>
    </div>
  );
}

export default AddSchedule;
